import {createRoot} from 'react-dom/client'
// auth provider
// import {AuthProvider} from 'pages/module/auth'
// chart config
import {Chart, registerables} from 'chart.js'
// toastify
import {ToastContainer} from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
// routes
import {AppRoutes} from 'routing/AppRoutes'
// store redux
import {store} from 'redux/store/index'
import {Provider} from 'react-redux'

import {AuthProvider} from 'context/AuthProvider'
/**
 * TIP: Replace this style import with rtl styles to enable rtl mode
 *
 * import './_swooosh/assets/css/style.rtl.css'
//  **/
import './index.css'
// chart register
Chart.register(...registerables)

const container = document.getElementById('root')

if (container) {
 createRoot(container).render(
  <Provider store={store}>
   {/* we use redux */}
   {/* provides language support */}
   {/* include/added login and sign up routes */}
   <AuthProvider>
    <AppRoutes />
    <ToastContainer /> {/* original routes */}
   </AuthProvider>
  </Provider>
 )
}
